export class FormRule {
  constructor(executor) {
    this.executor = executor;
  }

  create(form, model, key, injections) {
    return (newVal, oldVal) => {
      return this.executor(form, model, key, injections, newVal, oldVal);
    };
  }
}
